import styled from "styled-components";
import { Grid, SecondaryMenu, ArrowScroll } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LayoutStyled = styled.section`
  width: 100%;
  top: 0;
  bottom: 0;
  position: absolute;
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
`;
export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  display: ${props => (props.isVisible ? "block" : "none")};
`;

export const FullCatalogPageStyled = styled.section`
  padding-left: ${props => props.theme.baseLayoutPaddingBs}%;
  padding-right: ${props => props.theme.baseLayoutPaddingBs}%;
  height: 100%;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: ${props =>
      props.background &&
      `url(${props.background}) ${
        props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? `19vw` : `-6vw`
      } 0 / contain no-repeat`};
    transition: opacity 0.2s linear;
    will-change: opacity;
    opacity: ${props => (props.background ? 1 : 0)};
  }
`;

export const BlockStyled = styled.div`
   & {
    ${props =>  props.isTabExits  ? 'width: 80%' : 'width: 100%'}
    ${props => props.isTabExits && props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT && "border-left: solid 3px;"}
    ${props =>
      props.isTabExits && props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && "border-right: solid 3px;"} 
    border-color: #2C2D35;
  }
`;

export const BlockStyledTabs = styled.div`
  & nav {
    // margin-right: 3rem;
    ${props =>  props.isTabExits  ? 'margin-right: 3rem' : 'margin-right: 0rem'}
    ${props =>  props.isTabExits  ? 'margin-left: 2rem' : 'margin-left: 0rem'}
    // margin-left: 2rem;
  }
  & nav ul li {
    font-size: 1.6rem;
    font-weight: 900;
  }
`;


export const GridStyled = styled(Grid)`
  display: block;
  position: absolute;
  margin-${props => (props.isTabExits && (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right"))}: ${props =>
  `calc(${props.theme.components.carousel.slideMargin.default} * 6)`};
  & .ReactVirtualized__Grid__innerScrollContainer  .cropped {
    opacity: 0 !important;
  }
  & .Styled__ImageContainerStyled-t5q7es-1 img{
    width: auto;
    height: 100%;
  }
  & .selected svg{
    fill:cyan !important;
  }
  & .selected span{
    opacity:1 !important;
  }
  
  & .ReactVirtualized__Grid__innerScrollContainer {
     overflow:visible !important;
  }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    position : absolute;
    width:100%;
    display: flex;
    justify-content: center;
    // border: 4px solid rgba(100,105,121,0.5) !important;
    border-radius: 16px;
    border-radius: 1.4rem !important;

  }
`;

export const SecondaryMenuStyled = styled(SecondaryMenu)`
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: -${props.theme.spacing.xsmall}`};
`;

export const TextNoFound = styled.div`
      color: #f1f1f1;
      font-size: 1.5rem;
      margin-bottom: 0.8rem;
      letter-spacing: 0.038rem;
      line-height: 1.5;
      position: relative;
      margin-top: 7rem;
      text-align: center;
`;